import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, Box, Card, Chip, Divider, CardContent, CardHeader } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import React from "react"
import SimpleTable from "../table/Table"
import OrderManagerTable from "../order-manager-table/OrderManagerTable"
import OrderManagerCard from "../order-manager-card/OrderManagerCard"
import { classes } from "istanbul-lib-coverage"
import { OrderQueueOriginType } from "../../state/constants/OrderQueueOriginType"
import { Loading } from "../loading/Loading"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles({
    orderCard: {
        marginBottom: "30px",
        backgroundColor: "#fafafa"
    },
    relatedOrdersCard: {
        marginTop: "30px",
        backgroundColor: "#fafafa"
    },
    noRelatedOrderStatusesTypography: {
        opacity: 0.2,
        textAlign: "center"
    }
})

export default function OrderManagerDetailDialog({ open, fullWidth, orderDetails, ...props }) {
    const classes = useStyles()
    const [t, i18n] = useTranslation()
    const orderData = orderDetails.data
    const type = orderDetails.type
    const relatedOrdersData = props.relatedOrders

    function createDetails(item) {
        return {
            // title: item.CustomerId,
            // id: item.CustomerId,
            // source: item.SourceName,
            // status: item.Status,
            details: [
                {
                    title: t('order-manager.order-type'),
                    value: item.OrderType
                },
                {
                    title: t('order-manager.order-date'),
                    value: new Date(item.UpdateDate || "").toLocaleString()
                },
                {
                    title: t('order-manager.middleware-id'),
                    value: item.MiddlewareId
                },
                {
                    title: t('order-manager.order-no'),
                    value: item.OrderId
                },
                {
                    title: t('order-manager.order-quantity'),
                    value: t("order-manager.order-quantity-merge", { cases: t("order-manager.order-quantity-case", { count: item.TotalCases }), eaches: t("order-manager.order-quantity-each", { count: item.TotalEaches }) })
                },
                {
                    title: t('order-manager.total'),
                    value: item.TotalPrice
                }
            ]
        }
    }

    function renderRelatedOrders() {
        return (props.relatedOrdersLoading ? <Loading /> : (relatedOrdersData != null && relatedOrdersData.length > 0) ?
            <Grid container spacing={1}>
                {relatedOrdersData.map(item => (
                    <Grid item>
                        <Chip variant="outlined" label={`${item.data.Status} ${new Date(item.data.UpdateDate || "").toLocaleString()}`} />
                    </Grid>
                ))}
            </Grid> :
            <Box className={classes.noRelatedOrderStatusesTypography}>
                <Typography variant="body1" >
                    {t('order-manager.no-other-order-statuses')}
                </Typography>
            </Box>
        )
    }

    return (
        <Dialog
            open={open}
            maxWidth='lg'
            fullWidth='lg'
            onClose={props.onClose}
        >
            {
                type !== OrderQueueOriginType.Order ?
                    <DialogTitle>{type}</DialogTitle> :
                    null
            }
            <DialogContent>
                {
                    type === OrderQueueOriginType.Order ?
                        <Box>
                            <OrderManagerCard
                                className={classes.orderCard}
                                id={orderData.id}
                                title={orderData.CustomerId}
                                subtitle={orderData.CustomerId + " | " + orderData.SourceName}
                                status={orderData.Status}
                                data={createDetails(orderData).details}
                            />
                            <OrderManagerTable
                                rows={orderData.Items}
                                emptyPlaceholder={t('order-manager.no-products-in-this-order')}
                            />
                            <Card className={classes.relatedOrdersCard}>
                                <CardHeader title={t('order-manager.other-order-statuses')} />
                                <CardContent>
                                    {renderRelatedOrders()}
                                </CardContent>
                            </Card>
                        </Box> :
                        <Typography>
                            <pre>
                                {JSON.stringify(orderData, null, 4)}
                            </pre>
                        </Typography>
                }

            </DialogContent>
            <DialogActions>{props.actions}</DialogActions>
        </Dialog>
    )
}